// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4h-1";
export var standaloneTable = "_4h-0";